import {Box, Flex, Image, Text} from "@mantine/core";
import {IconMinus, IconPlus} from "@tabler/icons-react";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';


const _CartItem4 = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Box
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
                px={component?.customize_styles?.box_decoration?.padding_x}
                py={component?.customize_styles?.box_decoration?.padding_y}
                bg={component?.customize_styles?.box_decoration?.background_color}
                style={{
                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                }}
            >
                <Flex justify={"space-between"} align={"center"} mb={15}>
                    <Flex
                        h={105}
                        w={60}
                        px={15}
                        py={10}
                        mr={10}
                        justify={"space-between"}
                        align={"center"}
                        style={{
                            background: "linear-gradient(180deg, #2D82FF 0%, #0566F5 100%)",
                            borderRadius: "10px",
                            flexDirection: "column",
                        }}
                    >
                        <IconPlus color="#ffffff" size={22} style={{cursor: "pointer"}}/>
                        <Text my={15} c={"#ffffff"} fz={14} fw={400}>
                            {" "}
                            1{" "}
                        </Text>
                        <IconMinus
                            color="#ffffff"
                            size={22}
                            style={{cursor: "pointer"}}
                        />
                    </Flex>
                    <Flex
                        h={105}
                        w={265}
                        justify={"flex-start"}
                        align={"center"}
                        bg={"#ffffff"}
                        p={10}
                        style={{borderRadius: "25px"}}
                        gap="xs"
                    >
                        <Box
                            w={component?.customize_styles?.image_decoration?.width}
                            h={component?.customize_styles?.image_decoration?.height}
                            // bg={component?.customize_styles?.image_decoration?.color}
                            style={{
                                borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`
                            }}
                        >
                            <Image
                                style={{ width: "100%", height: "100%" }}
                                src=""
                                fallbackSrc={ProductPlaceholderImage}
                                alt=""
                                radius={component?.customize_styles?.image_decoration?.radius}
                            />
                        </Box>
                        <Box>
                            <Text
                                lineClamp={1}
                                translate="yes"
                                c={component?.customize_styles?.name_text_decoration?.color}
                                fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                fz={component?.customize_styles?.name_text_decoration?.font_size}
                                fs={component?.customize_styles?.name_text_decoration?.font_style}
                            >
                                Product Name
                            </Text>
                            <Text
                                mt={3}
                                fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                c={component?.customize_styles?.product_price_text_decoration?.color}
                                // bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                ta={component?.customize_styles?.product_price_text_decoration?.text_align}
                            >
                                $00.00
                            </Text>
                        </Box>
                    </Flex>
                </Flex>
            </Box>

        </Box>
    )
}
export default _CartItem4;